import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import DocumentFilledIcon from '@atlaskit/icon/core/file';
import LegacyDocumentFilledIcon from '@atlaskit/icon/glyph/document-filled';
import { Card } from '@atlaskit/media-card';
import { FilmstripView } from '@atlaskit/media-filmstrip';
import { formatFilesWithEditActions, sortFilesYoungestFirstOnLeft } from '../../../../../common/utils';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { DragCardContainer } from '../../../styled';
var DEFAULT_ATTACHMENT_DIMENSIONS = {
  height: 100,
  width: 150
};
var DragPlaceholder = function DragPlaceholder() {
  return /*#__PURE__*/React.createElement(DragCardContainer, null, /*#__PURE__*/React.createElement(DocumentFilledIcon, {
    color: "currentColor",
    label: "Document",
    LEGACY_size: "medium",
    spacing: "spacious",
    LEGACY_fallbackIcon: LegacyDocumentFilledIcon
  }));
};
var AttachmentsFilmstripView = function AttachmentsFilmstripView(props) {
  var uploadedFiles = props.uploadedFiles,
    existingFiles = props.existingFiles,
    mediaClientConfigRead = props.mediaClientConfigRead,
    mediaClientConfigUpload = props.mediaClientConfigUpload,
    _props$attachmentDime = props.attachmentDimensions,
    attachmentDimensions = _props$attachmentDime === void 0 ? DEFAULT_ATTACHMENT_DIMENSIONS : _props$attachmentDime,
    onRemoveFile = props.onRemoveFile,
    collectionNameUpload = props.collectionNameUpload,
    collectionNameExisting = props.collectionNameExisting,
    isOnDrag = props.isOnDrag;
  var _useState = useState({
      animate: false,
      offset: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    animateAndOffset = _useState2[0],
    setAnimateAndOffset = _useState2[1];
  if (!mediaClientConfigRead || !mediaClientConfigUpload) {
    return null;
  }
  var formattedUploadedFiles = formatFilesWithEditActions(uploadedFiles, mediaClientConfigUpload, collectionNameUpload, onRemoveFile);
  var formattedExistingFiles = formatFilesWithEditActions(existingFiles, mediaClientConfigUpload, collectionNameExisting, onRemoveFile);
  var animate = animateAndOffset.animate,
    offset = animateAndOffset.offset;
  var onScroll = function onScroll(e) {
    setAnimateAndOffset({
      animate: e.animate,
      offset: e.offset
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FilmstripView
  // @ts-expect-error - TS2322 - Type '{ children: Element[]; mediaClientConfig: MediaClientConfig; onScroll: (e: ScrollEvent) => void; animate: boolean; offset: number; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<FilmstripView> & Pick<Readonly<FilmstripViewProps> & Readonly<...>, never> & Partial<...> & Partial<...>'.
  , {
    mediaClientConfig: mediaClientConfigRead,
    onScroll: onScroll,
    animate: animate,
    offset: offset
  }, mediaClientConfigUpload && formattedUploadedFiles.sort(function (a, b) {
    return sortFilesYoungestFirstOnLeft(a, b);
  }).map(function (file) {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "proforma-attachment-field-card",
      key: file.identifier.id.toString()
    }, /*#__PURE__*/React.createElement(Card, {
      key: file.identifier.id.toString(),
      mediaClientConfig: mediaClientConfigUpload,
      identifier: file.identifier
      // @ts-expect-error - TS2322 - Type 'CardAction[]' is not assignable to type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/@atlaskit/media-card/dist/types/actions").CardAction[]'.
      ,
      actions: file.actions,
      shouldOpenMediaViewer: true,
      dimensions: attachmentDimensions
    }));
  }), mediaClientConfigRead && formattedExistingFiles.sort(function (a, b) {
    return sortFilesYoungestFirstOnLeft(a, b);
  }).map(function (file) {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "proforma-attachment-field-card",
      key: file.identifier.id.toString()
    }, /*#__PURE__*/React.createElement(Card, {
      key: file.identifier.id.toString(),
      mediaClientConfig: mediaClientConfigRead,
      identifier: file.identifier
      // @ts-expect-error - TS2322 - Type 'CardAction[]' is not assignable to type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/@atlaskit/media-card/dist/types/actions").CardAction[]'.
      ,
      actions: file.actions,
      shouldOpenMediaViewer: true,
      dimensions: attachmentDimensions
    }));
  })), isOnDrag && /*#__PURE__*/React.createElement(FilmstripView, {
    offset: offset
  }, /*#__PURE__*/React.createElement(DragPlaceholder, null)));
};
export default AttachmentsFilmstripView;